import { MsalProvider } from '@azure/msal-react';

import { msalInstance } from '@m/utils/msalConfig';
import Providers from 'providers';

import Specialist from './Specialist';
import { AntdOverrides, GlobalStyles } from './SpecialistApp.styled';

export default function SpecialistApp() {
  return (
    <Providers defaultTheme="dark">
      <MsalProvider instance={msalInstance}>
        <Specialist />
      </MsalProvider>
      <AntdOverrides />
      <GlobalStyles />
    </Providers>
  );
}
